export default {
    namespaced: true,
    state: {
        mapPolyline: [],
        tripNumber: "",
        tripDetails: {},
    },
    getters: {
        getMapPolyline: state => state.mapPolyline,
        getTripNumber: state => state.tripNumber,
        getTripDetails: state => state.tripDetails,
    },
    mutations: {
        setMapPolyline(state, mapPolyline) {
            state.mapPolyline = mapPolyline;
        },
        setTripNumber(state, tripNumber) {
            state.tripNumber = tripNumber;
        },
        setTripDetails(state, tripDetails) {
            state.tripDetails = tripDetails;
        }
    },
    actions: {}
}